import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { InfoRounded as InfoRoundedIcon } from '@mui/icons-material';
import PaperFireworks from '@src/assets/images/paper-fireworks.svg';
import DialogWithContent from '@src/components/DialogWithContent';
import { removeQueryParams } from '@src/utils/url';
import {
  AUTO_APPLY_REFERRAL_PARAM,
  REFERRAL_CODE_PARAM,
} from '@src/constants/referral';
import actions from '@src/redux/actions';
import apis from '@src/apis';
import { useDispatch } from 'react-redux';
import {
  StyledReferralDialogContent,
  StyledReferralDialogNote,
} from './index.style';

const RedeemDialogSuccess = ({ open, onClose, credits, referralCode }) => {
  const location = useLocation();
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const dispatch = useDispatch();

  const handleClose = async () => {
    onClose();
    if (referralCode) {
      history.replace({
        pathname: location.pathname,
        search: removeQueryParams(location.search, [
          REFERRAL_CODE_PARAM,
          AUTO_APPLY_REFERRAL_PARAM,
        ]),
      });
    }
    // This is for update user info after redeem referral code
    // to make sure user can see the correct total characters
    const userRes = await apis.account.getMe();
    dispatch(actions.auth.updateUserInfo(userRes.result));
  };

  const renderContent = () => (
    <StyledReferralDialogContent>
      <Box className="character-container">
        <Typography className="character">
          {credits.toLocaleString(language)}
        </Typography>
        <Typography className="unit">{t('credits')}</Typography>
      </Box>
      <StyledReferralDialogNote>
        <InfoRoundedIcon className="note-icon" />
        <Typography className="note-text">
          {t('rewardFromReferralCodeInfo')}
        </Typography>
      </StyledReferralDialogNote>
    </StyledReferralDialogContent>
  );

  const renderAction = () => (
    <Button
      onClick={handleClose}
      variant="contained"
      className="dialog-actions-button"
    >
      {t('gotIt')}
    </Button>
  );

  return (
    <DialogWithContent
      image={PaperFireworks}
      title={t('rewardFromReferralCode')}
      actionComponent={renderAction()}
      open={open}
      onClose={onClose}
      contentPopup={renderContent()}
    />
  );
};

export default RedeemDialogSuccess;
